import logIt from "../../../logIt";

/**
 * A Pub-Sub event-cache
 */
export default class PubSub {
    // Pre-req: the using class must have this.key property defined
    publish() {
        // expects something like: {event: 'abc', data:{}}
        // Turn arguments object into a real array
        const args = Array.prototype.slice.call(arguments, 0);
        // Extract the first argument, the event object
        const e = args.shift();
        const cache = window.apexchat_event_cache || (window.apexchat_event_cache = {});
        // the following blocks are deliberately left to track illegal calls:-) See line#375: ApexChat.isInDevMode = false; ... so these blocks will never run in Test/Prod
        if (this.widget == undefined && ApexChat.isInDevMode) {
            logIt('PubSub.publish(): widget must be defined!');
        }
        if (e == undefined && ApexChat.isInDevMode) {
            logIt('PubSub.publish(): event must be in JSON format!');
        }
        const state = e.origin + e.state ? e.origin + e.state : e.event;
        logIt(`${this.widget}::publishing:${state}`);

        for (const w in cache) {
            const widget_cache = cache[w]; // get each widget cache
            if (widget_cache) {
                const handlers = widget_cache[state]; // get this event's subscriptions in a widget cache
                if (handlers) {
                    handlers.forEach((cb) => {
                        // call every callback attached with this event
                        const _args = e.data ? e.data : e.value;
                        cb(_args); // run callback with event data passed in
                    });
                }
            }
        }
        return this;
    }

    subscribe(event /* string */, callback) {
        const cache = window.apexchat_event_cache || (window.apexchat_event_cache = {});
        const widget_cache = cache[this.widget] || (cache[this.widget] = {});
        // the following blocks are deliberately left to track illegal calls:-) See line#375: ApexChat.isInDevMode = false; ... so these blocks will never run in Test/Prod
        if (this.widget == undefined && ApexChat.isInDevMode) {
            logIt('PubSub.subscribe(): widget must be defined!');
        }
        if (event == undefined && ApexChat.isInDevMode) {
            logIt('PubSub.subscribe(): event must be in string format!');
        }
        logIt(`${this.widget}::subscribing:${event}`);
        // Create an array for the given event key, unless it exists, then
        // append the callback to the array
        (widget_cache[event] || (widget_cache[event] = [])).push(callback);
        return this;
    }

    clearSubscriptions() {
        window.apexchat_event_cache[this.widget] = {};
    }

    allSubscriptions() {
        return window.apexchat_event_cache;
    }

    subscriptions() {
        return window.apexchat_event_cache[this.widget];
    }

    eventSubscriptions(evt) {
        // returns list of events subscribed or list of callback for the evt specified
        const cache = window.apexchat_event_cache || (window.apexchat_event_cache = {});
        const widget_cache = cache[this.widget] || (cache[this.widget] = {});
        if (evt) {
            return widget_cache[evt];
        }
        const events = [];
        for (const prop in widget_cache) {
            events.push(widget_cache[prop]);
        }
        return events;
    }
}
